import { get, chain } from "lodash"
import { createSelector } from "reselect"
import { getIsSuperuser } from "modules/account-root/selectors"
import { getRoute, getPath } from "selectors/urls"
import { computeDatasetPermissionsTabs } from "helpers/permissions/tabs"

function isDirectToken(entitlement) {
  return get(entitlement, "direct") && get(entitlement, "token")
}

const getRawDatasetEntitlements = (state) => get(state, "global.data.datasetEntitlements.data")

export const getDatasetTokens = createSelector(
  [getRawDatasetEntitlements],
  (entitlements) => chain(entitlements)
    .filter(isDirectToken)
    .map("token")
    .value(),
)

export const getTokens = (_, props) => get(props, "tokens.tokens")

export const getTabs = createSelector(
  [getRoute, getPath, getIsSuperuser],
  computeDatasetPermissionsTabs,
)
